import React, { useState, useEffect } from "react"; 

import { Row, Col, Container } from 'reactstrap';
import { useHistory } from 'react-router-dom';
  

//import { DefaultUi, Player, Youtube } from "@vime/react";
import {
    CommomContainer, 
    CommomTitle, 
    CommomText,
    CommomImageBanner,
    BannerLogo,
    BannerText,
    BannerCenterActions,
    CommomCentred,
    ContainerLoginContent,
    LoginContent
} from './styled'
import Button from "components/Button";

export default function Topo(){  

    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);

    // Hook para efeito de digitação
    const useTypingEffect = (texts, speed = 100, delay = 2000) => {
        const [currentTextIndex, setCurrentTextIndex] = useState(0);
        const [currentText, setCurrentText] = useState('');
        const [isDeleting, setIsDeleting] = useState(false);

        useEffect(() => {
            const timer = setTimeout(() => {
                const fullText = texts[currentTextIndex];
                
                if (!isDeleting && currentText !== fullText) {
                    setCurrentText(fullText.substring(0, currentText.length + 1));
                } else if (isDeleting && currentText !== '') {
                    setCurrentText(fullText.substring(0, currentText.length - 1));
                } else if (!isDeleting && currentText === fullText) {
                    setTimeout(() => setIsDeleting(true), delay);
                } else if (isDeleting && currentText === '') {
                    setIsDeleting(false);
                    setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
                }
            }, isDeleting ? speed / 2 : speed);

            return () => clearTimeout(timer);
        }, [currentText, isDeleting, currentTextIndex, texts, speed, delay]);

        return currentText;
    };

    // Nomes dos personagens para o efeito de digitação
    const personagens = [
        "Rei Salomão",
        "Profeta Daniel",
        "Rainha Ester",
        "Rei Davi",
    ];

    const currentPersonagem = useTypingEffect(personagens, 150, 1500);

    // Adicionar CSS para animação do cursor
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            @keyframes blink {
                0%, 50% { opacity: 1; }
                51%, 100% { opacity: 0; }
            }
        `;
        document.head.appendChild(style);
        
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return ( 
        <> 
            <ContainerLoginContent>   
                <Row>
                            <Col md={{ size: 4 }}></Col> 
                            <Col md={{ size: 4 }}>

                            </Col>
                            <Col md={{ size: 4 }}>
                                <LoginContent>
                                    <Button primary onClick={() => navigate('login')}>Entrar</Button>
                                </LoginContent>
                            </Col>
                </Row>
            </ContainerLoginContent>
            <CommomContainer>  
                <Container> 
                    
                    <Row>
                        <Col md={{size:6}}> 
                            <CommomCentred spaced>
                                <BannerLogo />
                                <BannerText>Entretenimento com sabedoria bíblica, em mais de 10 idiomas</BannerText>
                                <CommomTitle>
                                    <span style={{ fontSize: '1.1em', display: 'block' }}>
                                        Converse agora com
                                    </span>
                                    <span style={{ minHeight: '1.2em', display: 'inline-block', fontSize: '1.5em' }}>
                                        {currentPersonagem}
                                        <span style={{
                                            animation: 'blink 1s infinite',
                                            marginLeft: '2px',
                                            fontSize: '1.2em',
                                            fontWeight: 'normal'
                                        }}>|</span>
                                    </span>
                                </CommomTitle>
                                <CommomText>Imagine fazer uma pergunta a Salomão e receber uma resposta como ele daria. Perguntar a Davi como ele enfrentou o medo. Ouvir Ester falar sobre coragem. No TiqChat você conversa com personagens bíblicos recriados por IA — de forma leve, divertida e sempre interessante.</CommomText>
                                <CommomText style={{ fontSize: '13px', opacity: 0.5, marginTop: '8px' }}>🤖 Personagens recriados por IA — as respostas não substituem a leitura da Bíblia</CommomText>
                                <BannerCenterActions>
                                    <Button primary onClick={() => navigate('register?plan=free')}>Começar grátis</Button>
                                </BannerCenterActions>
                            </CommomCentred>
                        </Col>
                        <Col md={{size:6}}> 
                            <CommomCentred>
                                <CommomImageBanner />
                            </CommomCentred>
                        </Col>
                    </Row>
                </Container>
            </CommomContainer>
        </>
    );
}

//<Youtube videoId={`dUxUDhSRd8M`} key={`dUxUDhSRd8M`}/>
// na linha 32 <Player autoplay={true}>